import { ReactElement, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { errMsg } from "./api";

export const SUGGEST = ["Siapa saja yang menunggak lebih dari 2 bulan?", "Berapa total penerimaan bulan ini dibanding bulan lalu?", "Daftar 10 pinjaman dengan outstanding terbesar", "Berapa rasio NPL dan siapa yang masuk Col 5?", "Unit mana yang paling banyak menunggak?"];

export type Msg = { role: string; content: string };

export function Md({ text }: { text: string }) {
  const lines = text.split("\n");
  const inline = (s: string) => {
    const parts = s.split(/(\[[^\]]+\]\(\/[^)]+\)|\*\*[^*]+\*\*)/g);
    return parts.map((p, i) => {
      const link = p.match(/^\[([^\]]+)\]\((\/[^)]+)\)$/);
      if (link) return <Link key={i} to={link[2]} className="font-semibold text-primary underline underline-offset-2">{link[1]}</Link>;
      if (/^\*\*[^*]+\*\*$/.test(p)) return <b key={i}>{p.slice(2, -2)}</b>;
      return <span key={i}>{p}</span>;
    });
  };
  const out: ReactElement[] = [];
  for (let i = 0; i < lines.length; i++) {
    const l = lines[i];
    if (/^\s*\|/.test(l) || (l.includes("|") && /^\s*\|?[\s:|-]+\|?\s*$/.test(lines[i + 1] || ""))) {
      const rows: string[][] = [];
      while (i < lines.length && lines[i].includes("|")) { if (!/^\s*\|?[\s:|-]+\|?\s*$/.test(lines[i])) rows.push(lines[i].trim().replace(/^\||\|$/g, "").split("|").map((c) => c.trim())); i++; }
      i--;
      out.push(<div key={i} className="overflow-x-auto my-2"><table className="yt-table text-xs"><thead><tr>{rows[0]?.map((c, j) => <th key={j}>{inline(c)}</th>)}</tr></thead><tbody>{rows.slice(1).map((r, k) => <tr key={k}>{r.map((c, j) => <td key={j}>{inline(c)}</td>)}</tr>)}</tbody></table></div>);
    } else if (/^\s*[-*•]\s+/.test(l)) out.push(<li key={i} className="ml-4 list-disc">{inline(l.replace(/^\s*[-*•]\s+/, ""))}</li>);
    else if (/^\s*#+\s/.test(l)) out.push(<p key={i} className="font-semibold mt-2">{inline(l.replace(/^\s*#+\s/, ""))}</p>);
    else if (l.trim()) out.push(<p key={i}>{inline(l)}</p>);
  }
  return <div className="space-y-1 text-sm leading-relaxed">{out}</div>;
}

export function useAiChat(initialSid?: string) {
  const [sid, setSid] = useState(initialSid || `s-${Date.now().toString(36)}`);
  const [msgs, setMsgs] = useState<Msg[]>([]);
  const [busy, setBusy] = useState(false);
  const fresh = () => { setSid(`s-${Date.now().toString(36)}`); setMsgs([]); };

  const ask = async (message: string, onDone?: () => void) => {
    message = message.trim();
    if (!message || busy) return;
    setBusy(true);
    setMsgs((m) => [...m, { role: "user", content: message }, { role: "assistant", content: "" }]);
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/ai/chat`, { method: "POST", headers: { "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem("yef_token")}` }, body: JSON.stringify({ session_id: sid, message }) });
      if (!res.ok || !res.body) throw new Error((await res.json().catch(() => ({})))?.detail || `HTTP ${res.status}`);
      const reader = res.body.getReader(); const dec = new TextDecoder(); let buf = "";
      for (;;) {
        const { value, done } = await reader.read();
        if (done) break;
        buf += dec.decode(value, { stream: true });
        const events = buf.split("\n\n"); buf = events.pop() || "";
        for (const ev of events) {
          const data = ev.replace(/^data: /, "");
          if (data === "[DONE]") continue;
          const j = JSON.parse(data);
          if (j.error) throw new Error(j.error);
          setMsgs((m) => { const c = [...m]; c[c.length - 1] = { role: "assistant", content: c[c.length - 1].content + j.t }; return c; });
        }
      }
      onDone?.();
    } catch (e: any) { toast.error(e?.message || errMsg(e)); setMsgs((m) => m.slice(0, -1)); }
    finally { setBusy(false); }
  };
  return { sid, setSid, msgs, setMsgs, busy, ask, fresh };
}
